import { render, staticRenderFns } from "./UsertenantInviteForm.vue?vue&type=template&id=48d2fe0b&"
import script from "./UsertenantInviteForm.vue?vue&type=script&lang=js&"
export * from "./UsertenantInviteForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports